<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">
    Approccio ludico ed esperienziale al coding.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Insegnare i principi della programmazione attraverso esperienze ludiche che
    coinvolgono i bambini nella realizzazione di attività analogiche che
    affiancano l’utilizzo degli strumenti digitali. Il coding unplugged, è
    propedeutico alla programmazione con gli strumenti digitali.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/pencils.png"
        alt="Matite"
       
        class="pencil"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">Tutto senza utilizzare il computer.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Fare coding, ma senza utilizzare il computer. Le attività prevedono
    l’utilizzo di strumenti e materiali non digitali, che stimolino i bambini
    all’apprendimento dei meccanismi alla base dei
    <span class="underline-a">linguaggi di programmazione</span>
    che poi potranno tradurre al computer.
  </p>
</div>

<div class="fifth container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/puzzle.png"
        alt="Puzzle"
       
        class="puzzle"
      />
    </div>
  </div>
</div>

<div class="sixth container grid">
  <h3 class="w-700 blue-50 text-center">Algoritmi e sequenze logiche.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Gli alunni si cimenteranno nell’ideare
    <span class="underline-p">algoritmi</span> - sequenze logiche di istruzioni
    elementari - per raggiungere un obiettivo (per esempio “fare la cartella”,
    colorare eterminati quadretti per comporre un disegno), mettendoli alla
    prova attraverso il gioco e cercando di individuare i possibili errori che
    ne ostacolano la corretta esecuzione.
  </p>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
